import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAppAgendaContext } from '../context/AppAgendaContext';
import CryptoJS from 'crypto-js';


const Panel = styled.div`
  position: fixed;
  bottom: 12px;
  right: 12px;
  background-color: #ffffffee;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  font-size: 13px;
  color: #333;
  z-index: 9999;
  max-width: 350px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: monospace;
`;

const Section = styled.div`
  margin-bottom: 12px;
`;

const generarUrlFlujo = (claveFlujo) => {
  const SECRET_KEY = "clave_flujo_eme2024";
  const textoPlano = `claveFlujo=${claveFlujo}`;
  const encriptado = CryptoJS.AES.encrypt(textoPlano, SECRET_KEY).toString();
  const baseUrl = window.location.origin; // o define tu dominio base fijo
  const urlFinal = `${baseUrl}/?mp_flujo=${encodeURIComponent(encriptado)}`;
  return urlFinal;
};

const DebugPanel = () => {
  const {
    pasoActual,
    utmData,
    ultimoEventoGTM,
    sessionId,
    contextData,
    eventosLog
  } = useAppAgendaContext();

  const [mpFlujoTexto, setMpFlujoTexto] = useState(null);
  const [mpFlujoModo, setMpFlujoModo] = useState(null);

  useEffect(() => {
    if (contextData?.url_mpTipoTxt && contextData?.url_mpTipoVal) {
      setMpFlujoTexto(`${contextData.url_mpTipoTxt}_${contextData.url_mpTipoVal}`);
      setMpFlujoModo(
        contextData.url_mpTipoVal === '82'
          ? ' (por defecto)'
          : ' (desencriptado)'
      );
    }
  }, [contextData?.url_mpTipoTxt, contextData?.url_mpTipoVal]);

  console.log("🧪 DebugPanel - contextData:", contextData);

  return (
    <Panel>
      <Section>
        <strong>📍 Paso Actual:</strong><br />
        {pasoActual || 'No definido'}
      </Section>

      <Section>
        <strong>🧾 Session ID:</strong><br />
        {sessionId}
      </Section>

      <Section>
        <strong>📊 UTM Capturados:</strong><br />
        <div>source: {utmData?.source || '-'}</div>
        <div>medium: {utmData?.medium || '-'}</div>
        <div>campaign: {utmData?.campaign || '-'}</div>
        <div>term: {utmData?.term || '-'}</div>
        <div>content: {utmData?.content || '-'}</div>
      </Section>

      <Section>
        <strong>🖥️ Dispositivo:</strong><br />
        <div>Tipo: {contextData?.dispositivoTipo || '-'}</div>
        <div>SO: {contextData?.sistemaOperativo || '-'}</div>
        <div>Navegador: {contextData?.navegador || '-'}</div>
      </Section>

      <Section>
        <strong>📤 Último Evento GTM:</strong><br />
        {ultimoEventoGTM || 'Ninguno'}
      </Section>

      <Section>
        <strong>🧑‍⚕️ RUT Paciente:</strong><br />
        {contextData?.pacRut || 'No ingresado'}
      </Section>

      <Section>
        <strong>🔐 MP_Flujo:</strong><br />
        {mpFlujoTexto ? `${mpFlujoTexto}${mpFlujoModo}` : 'Valor no definido'}
      </Section>

      <Section>
        <strong>🔐 Generador de URL Fija:</strong><br />
        <div>
          <input
            type="text"
            placeholder="claveFlujo (ej: landing_doctor_x)"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                const url = generarUrlFlujo(e.target.value.trim());
                console.log("🔗 URL generada:", url);
                alert(`URL generada:\n${url}`);
              }
            }}
            style={{ width: '100%', padding: '4px', fontSize: '12px', marginTop: '6px' }}
          />
          <div style={{ fontSize: '11px', marginTop: '4px', color: '#888' }}>
            Pulsa Enter para generar URL en consola.
          </div>
        </div>
      </Section>

      <Section>
        <strong>🔎 FlujoActivo (clave y sucursales):</strong><br />
        <div>Clave: {contextData?.claveFlujo || '-'}</div>
        <div>Tipo: {contextData?.url_mpTipoTxt || '-'}</div>
        <div>Valor: {contextData?.url_mpTipoVal || '-'}</div>
        <div>SucursalesPermitidas:</div>
        <ul>
          {(contextData?.sucursalesPermitidas || []).map((suc, i) => (
            <li key={i}>{suc}</li>
          ))}
        </ul>
      </Section>

      <Section>
        <strong>📝 Últimos Eventos:</strong><br />
        {eventosLog.length === 0 ? (
          <div>-</div>
        ) : (
          eventosLog.map((e, idx) => (
            <div key={idx} style={{ marginBottom: '4px' }}>
              <strong>{e.paso}</strong> - {e.evento}<br />
              <em>{e.descripcion}</em> ({e.timestamp})
            </div>
          ))
        )}
      </Section>
    </Panel>
  );
};

export default DebugPanel;
